<!-- {{'ROOT.SHARED.SHARED_TEXT'|translate}}

{{'ROOT.ROOT_TEXT'|translate}}

{{'ROOT.SHARED.UILM.APP'|translate}} -->

<ngx-pull-to-refresh
    spinnerColor="#ffd900"
    distanceForRefresh="40"
    [isEnable]="pullEnabled"
    [targetElement]="targetElement"
    customClass="pullRefreshCustomClass"
    (refresh)="refreshPage($event, 'refresh')"
    style="display: block; height: 100%; width: 100%"
>
    <fuse-main
        [navigations]="navigations"
        [appList]="apps"
        [toolbarComponent]="toolbarComponent"
        [quickPanelComponent]="quickPanelComponent"
    ></fuse-main>
</ngx-pull-to-refresh>
